import React from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { useState, useEffect, useContext } from "react";

//Import Context
import {AppContext} from '../../App'

//Import Css
import './contactanos.css'

//Import Assets
import photoAgent from '../../assets/contactAssets/photo-agent.png'
import photoCamaraContact from '../../assets/contactAssets/camara-contact.jpg'
import iconSend from '../../assets/contactAssets/icon-send.svg'
import logoContactMonitronix from '../../assets/contactAssets/logo-monitronix-contact.svg'

//Import Component
import MenuScrollBarComponent from "../menuScrollBarComponent/menuScrollBarComponent";
import {FooterComponent} from '../footerComponent/footerComponent';


export default function Contactanos() {


    const {

    // Props Menu Bar Scroll Page
      linkUrl,
      nameClass,
      namePage

    } = useContext(AppContext); 

    return(

        <div className="container-contactanos-component">
      
            {/* // Sección menú scroll bar */}
            <div className="container-menu-component">
        
                <MenuScrollBarComponent 
                
                        linkUrl1={linkUrl[0]}
                        linkUrl2={linkUrl[1]}
                        linkUrl3={linkUrl[2]}
                        linkUrl4={linkUrl[3]}
        
                        nameClass1={nameClass[0]}
                        nameClass2={nameClass[1]}
                        nameClass3={nameClass[2]}
                        nameClass4={nameClass[3]}
                    
                        namePage1={namePage[0]}
                        namePage2={namePage[1]}
                        namePage3={namePage[2]}
                        namePage4={namePage[3]}
                
                />
        
            </div>


            {/* // Sección Formulario de contacto */}
            <div className="container-form-contact">

                {/* Contenedor Cuadro Blanco */}
                <div className="box-main-form-monitronix">
                    
                    <div className="box-form-contact">

                        <div className="box-title-text-agent">

                            <div className="box-title-text-contact">

                                <h2 className="title-contact">CONTÁCTANOS</h2>
                                <p className="text-contact">Envíanos un email direct y nos pondremos en contacto de  inmediato.</p>

                            </div>

                            <div className="box-photo-contact">

                                    <img className="photo-contact" src={photoAgent} alt="Contáctanos Monitronix"/>
                            </div> 

                        </div>


                        <form className="box-label-conteiner" action="#" method="POST">
                            {/* Campo Nombre */}
                            <label htmlFor="nombre" className="sr-only label-style">Nombre</label>
                            <input type="text" id="nombre" name="nombre" placeholder="Nombre" required />

                            {/* Campo Asunto */}
                            <label htmlFor="asunto" className="sr-only label-style">Asunto</label>
                            <input type="text" id="asunto" name="asunto" placeholder="Asunto" required />

                            {/* Campo Mensaje */}
                            <label htmlFor="mensaje" className="sr-only label-style">Mensaje</label>
                            <textarea id="mensaje" name="mensaje" placeholder="Mensaje" rows="5" required></textarea>

                            {/* Botón de envío */}
                            <button className="email-send" type="submit"> Enviar <img className="icon-Send" src={iconSend} alt="Icono de envío" /></button>
                        </form>


                    </div>

                    {/* Background Box Photo Contact */}
                    <div className="box-photo-section"></div>

                </div>


            </div>

            {/* // Seccion Footer */}
            <div className="footer-container-home">
                <FooterComponent />

            </div>

        </div>

    );
    
}